import { createRoutine } from 'redux-saga-routines';

export const fetchOutreaches = createRoutine('FETCH_OUTREACHES');
export const createOutreach = createRoutine('CREATE_OUTREACH');
export const updateOutreach = createRoutine('UPDATE_OUTREACH');
export const deleteOutreach = createRoutine('DELETE_OUTREACH');
